import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import AdminDashboardHtml      from './admin-dashboard.html';
import CompaniesHtml           from './admin-dashboard.companies.html';
import CompanyManageHtml       from '../companies/company.manage.html';
import ManageAdvertisementHtml from './admin-dashboard.manage-advertisement.html';

export function AdminDashboardStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'ManageAdvertisementCtrl',
    name       : 'app.manage-advertisement',
    templateUrl: ManageAdvertisementHtml,
    url        : '/manage_advertisement',
    resolve    : {
      advertisementUrl: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/dashboard/workshop_ad_link')
    }
  })
  .state({
    controller : 'adminDashboardCtrl',
    name       : 'app.admin-dashboard',
    templateUrl: AdminDashboardHtml,
    url        : '/admin_dashboard',
    resolve    : {
      advertisementUrl: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/dashboard/workshop_ad_link'),
      notifications   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system_notifications'),
      user            : ( sessionObjAPI : SessionService, workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/user', sessionObjAPI.user().id)
    }
  })
  .state({
    controller : 'CompaniesCtrl',
    name       : 'app.companies',
    templateUrl: CompaniesHtml,
    url        : '/companies',
    resolve    : {
      companies: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.stream('/filters', [
        '*',
        'companies',
        0,
        11,
        'company_name',
        'asc',
        false
      ])
    }
  })
  .state({
    controller: 'companyManagementCtrl',
    name      : 'app.manage-company',
    params    : {
      tab: { squash: true, value: null }
    },
    templateUrl: CompanyManageHtml,
    url        : '/manage_company/:id/:tab',
    resolve    : {
      company: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService) : ng.IPromise<any> => workshopAPI.get('workshop_admin/company_and_chargify_status', $stateParams.id),
      users  : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService) : ng.IPromise<any> => workshopAPI.get('workshop_admin/user_index', [ $stateParams.id, 0, '*', 'email', 'desc' ])
    }
  });
}